import { getProcessEnv } from '../../utils/env'
import urls from '../../utils/urls'

export default urls({
	APP_URL          : getProcessEnv('VUE_APP_OM_BASE_APP_URL'),
	MARKETING_URL    : getProcessEnv('VUE_APP_OM_BASE_MARKETING_URL'),
	SHAREABLE_URL    : getProcessEnv('VUE_APP_OM_BASE_SHAREABLE_URL'),
	API_URL          : getProcessEnv('VUE_APP_OM_BASE_API_URL'),
	TP_APP_URL       : getProcessEnv('VUE_APP_TP_BASE_APP_URL'),
	CDN_URL          : getProcessEnv('VUE_APP_OM_BASE_CDN_URL'),
	API_JS_URL       : getProcessEnv('VUE_APP_OM_API_JS_URL'),
	HOTNOW_URL       : getProcessEnv('VUE_APP_OM_HOTNOW_URL'),
	WP_DEV_URL       : getProcessEnv('VUE_APP_WP_DEV_URL'),
	WP_REST_API_URL  : getProcessEnv('VUE_APP_WP_REST_API_URL'),
	WP_ADMIN_API_URL : getProcessEnv('VUE_APP_WP_ADMIN_API_URL'),
})
